import { createFileRoute } from '@tanstack/react-router'

import { CenteredLayout } from '~/layout/centered-layout'

export const Route = createFileRoute('/subscription')({
  component: CenteredLayout,
})
